import { useEffect, useState } from 'react'
import LoadingButton from '@mui/lab/LoadingButton'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import { useGetCampaignsQuery } from '../../campaigns/slice'
import { useUnassignProspectsFromCampaignMutation } from '../slice'

const RemoveFromCampaign = ({ prospectIds, campaignId, open, setOpen }) => {
  const [unassignProspectsFromCampaign, { isLoading }] = useUnassignProspectsFromCampaignMutation()
  const { data: campaigns, isLoading: isCampaignsLoading } = useGetCampaignsQuery()
  const [campaign, setCampaign] = useState(null)

  useEffect(() => {
    if (campaigns) {
      setCampaign(campaigns.find((campaign) => campaign.id === campaignId))
    }
  }, [campaigns, campaignId, setOpen])

  const handleClose = () => {
    setOpen(false)
  }

  const handleUnassign = async () => {
    await unassignProspectsFromCampaign({ prospectIds, campaignId })
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{`Remove prospects from campaign?`}</DialogTitle>
      <DialogContent dividers>
        {isCampaignsLoading && <DialogContentText>Loading...</DialogContentText>}
        {!isCampaignsLoading && (
          <DialogContentText>
            You are about to remove {prospectIds.length} prospect(s) from the campaign "{campaign?.name}". Are you sure
            you want to do this?
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <LoadingButton disabled={isLoading} onClick={handleClose} autoFocus>
          Cancel
        </LoadingButton>
        <LoadingButton color="error" loading={isLoading} onClick={handleUnassign}>
          Remove
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveFromCampaign
